/**
 * Component Registry for Prairie Creek Apartments & Townhomes
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import SisterProperties from './components/SisterProperties';
import PropertyOverview from './components/PropertyOverview';
import TabbedCallouts from './components/TabbedCallouts';
import Footer from './components/Footer';
import PhotoGallery from './components/PhotoGallery';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  SisterProperties,
  PropertyOverview,
  TabbedCallouts,
  Footer,
  PhotoGallery,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
